module.exports = __webpack_public_path__ + "img/scholarship1.541f2f38.png";